module.exports = __webpack_public_path__ + "img/文化服务.8881897e.png";